module.exports = __webpack_public_path__ + "img/Save.9dbd5e23.svg";